<!-- Sección 0: Nuestros productos -->
<div id="services-productos" class="services-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>{{ 'services.products.title' | translate }} <span>{{ 'services.products.highlight' | translate }}</span></h2>
            <p>{{ 'services.products.subtitle' | translate }}</p>
        </div>
        <div class="mothers-row" [class.mothers-hidden]="showProductosDetail">
            <div class="row justify-content-center mb-4">
                <div class="col-lg-4 col-md-6">
                    <div class="single-services single-services-titulo expand-trigger" (click)="toggleProductosDetail()" role="button" tabindex="0" (keydown.enter)="toggleProductosDetail()">
                        <div class="services-img">
                            <img src="assets/images/aplicaciones_cuadro_principal.png" [attr.alt]="'services.products.appsAlt' | translate">
                            <div class="icon" hidden>
                                <i class="fas fa-box"></i>
                            </div>
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.appsTitle' | translate }}</h3>
                            <p>{{ 'services.products.appsText' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-block" [class.expanded]="showProductosDetail">
            <div class="detail-block-header">
                <button type="button" class="btn-volver" (click)="closeProductosDetail()" [attr.aria-label]="'services.closeAria' | translate">
                    {{ 'services.close' | translate }} <i class="fas fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="row justify-content-center">
                <div class="section-subtitle ms-2 mb-2">
                    <h4>{{ 'services.products.appsTitle' | translate }}</h4>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-services">
                        <div class="services-img">
                            <img src="assets/images/img_sistema_360.png" [attr.alt]="'services.products.eval360Title' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.eval360Title' | translate }}</h3>
                            <p>{{ 'services.products.eval360Text' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-services">
                        <div class="services-img">
                            <img src="assets/images/img_gestion_documental.png" [attr.alt]="'services.products.docTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.docTitle' | translate }}</h3>
                            <p>{{ 'services.products.docText' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-services">
                        <div class="services-img">
                            <img src="assets/images/img_sistema_integral_fidelizacion.png" [attr.alt]="'services.products.loyaltyTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.loyaltyTitle' | translate }}</h3>
                            <p>{{ 'services.products.loyaltyText' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-services">
                        <div class="services-img">
                            <img src="assets/images/img_sistema_riesgo.png" [attr.alt]="'services.products.riskTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.riskTitle' | translate }}</h3>
                            <p>{{ 'services.products.riskText' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-services">
                        <div class="services-img">
                            <img src="assets/images/img_sistema_gestion_proyectos.png" [attr.alt]="'services.products.pmTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.products.pmTitle' | translate }}</h3>
                            <p>{{ 'services.products.pmText' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sección 1: Nuestros Servicios → Ingeniería de Software -->
<div id="services-software" class="services-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>{{ 'services.list.title' | translate }} <span>{{ 'services.list.highlight' | translate }}</span></h2>
            <p>{{ 'services.list.subtitle' | translate }}</p>
        </div>
        <div class="mothers-row" [class.mothers-hidden]="servicesMothersHidden">
            <div class="row justify-content-center mb-4">
                <div class="col-lg-4 col-md-5">
                    <div class="single-services single-services-titulo expand-trigger" (click)="toggleSoftwareDetail()" role="button" tabindex="0" (keydown.enter)="toggleSoftwareDetail()">
                        <div class="services-img">
                            <img src="assets/images/6UiUxDesign.png" [attr.alt]="'services.list.softwareTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.list.softwareTitle' | translate }}</h3>
                            <p>{{ 'services.list.softwareText' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-5">
                    <div class="single-services single-services-titulo expand-trigger" (click)="toggleConstruccionDetail()" role="button" tabindex="0" (keydown.enter)="toggleConstruccionDetail()">
                        <div class="services-img">
                            <img src="assets/images/6Gestionproyectos.png" [attr.alt]="'services.list.constructionTitle' | translate">
                        </div>
                        <div class="services-content">
                            <h3>{{ 'services.list.constructionTitle' | translate }}</h3>
                            <p>{{ 'services.list.constructionText' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-block" [class.expanded]="showSoftwareDetail">
            <div class="detail-block-header">
                <button type="button" class="btn-volver" (click)="closeAllDetails()" [attr.aria-label]="'services.closeAria' | translate">
                    {{ 'services.close' | translate }} <i class="fas fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="row justify-content-center">
                <div class="section-subtitle ms-2 mb-2">
                    <h4>{{ 'services.list.softwareTitle' | translate }}</h4>
                </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/1ArquitecturadisenodesarrollofullstackAplicaciones.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-pencil-alt"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.fullstackTitle' | translate }}</h3>
                        <p>{{ 'services.list.fullstackText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/2SistematizacionIntegracionProcesosNegocios.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fab fa-linode"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.integrationTitle' | translate }}</h3>
                        <p>{{ 'services.list.integrationText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/3DisenoDesarrolloimplantacionSistemas.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-desktop"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.systemsTitle' | translate }}</h3>
                        <p>{{ 'services.list.systemsText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/4DisenoDesarrolloAppnativashibridas.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-chart-line"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.appsTitle' | translate }}</h3>
                        <p>{{ 'services.list.appsText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/5Migracionsistemas.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-anchor"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.migrationTitle' | translate }}</h3>
                        <p>{{ 'services.list.migrationText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/6UiUxDesign.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-headphones-alt"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.uiuxTitle' | translate }}</h3>
                        <p>{{ 'services.list.uiuxText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/img_analitica_datos.png" [attr.alt]="'services.list.analyticsAlt' | translate">
                        <div class="icon" hidden>
                            <i class="fas fa-chart-bar"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.analyticsTitle' | translate }}</h3>
                        <p>{{ 'services.list.analyticsText' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="detail-block" [class.expanded]="showConstruccionDetail">
            <div class="detail-block-header">
                <button type="button" class="btn-volver" (click)="closeAllDetails()" [attr.aria-label]="'services.closeAria' | translate">
                    {{ 'services.close' | translate }} <i class="fas fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="row justify-content-center">
                <div class="section-subtitle ms-2 mb-2">
                    <h4>{{ 'services.list.constructionTitle' | translate }}</h4>
                </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/6Gestionproyectos.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-mobile-alt"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.pmTitle' | translate }}</h3>
                        <p>{{ 'services.list.pmText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/7ElaboracionProyectosIngenieriaAplicada.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="fas fa-camera-retro"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.appliedTitle' | translate }}</h3>
                        <p>{{ 'services.list.appliedText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/8Energia.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.energyTitle' | translate }}</h3>
                        <p>{{ 'services.list.energyText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/9Ducteria.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.ductTitle' | translate }}</h3>
                        <p>{{ 'services.list.ductText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/10DisenoProduccionconstruccionfuentesrobotizadas.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.fountainsTitle' | translate }}</h3>
                        <p>{{ 'services.list.fountainsText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/11CentrosProcesamientoDeDatosDomotica.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.dataTitle' | translate }} </h3>
                        <p>{{ 'services.list.dataText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/12FibraOptica.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.fiberTitle' | translate }}</h3>
                        <p>{{ 'services.list.fiberText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/13GasesMedicinales.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.gasTitle' | translate }}</h3>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/14UrbanismoMovimientosTierraVialidad.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.urbanismTitle' | translate }}</h3>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/15DisenoFabricacionVentalucesLED.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.ledTitle' | translate }}</h3>
                        <p>{{ 'services.list.ledText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/16CableadotensionmediaBaja.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.cableTitle' | translate }} </h3>
                        <p>{{ 'services.list.cableText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/17DesalinizadorasDepuradorasAgua.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.waterTitle' | translate }}</h3>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/18Proyectosdeportivosafines.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.sportTitle' | translate }}</h3>
                        <p>{{ 'services.list.sportText' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services">
                    <div class="services-img">
                        <img src="assets/images/19ProcuraMateriales.png" alt="services-img">
                        <div class="icon" hidden>
                            <i class="far fa-life-ring"></i>
                        </div>
                    </div>
                    <div class="services-content">
                        <h3>{{ 'services.list.assistTitle' | translate }}</h3>
                        <p>{{ 'services.list.assistText' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
